<template>
  <div class="pop-body" v-if="activeIdentity">
    <!--App拍摄资料-->
    <div class="app-data" v-if="activeIdentity.elec.length > 0">
      <div class="flexed-list-header">
        <span class="red-Popsicles"></span>
        <p>App拍摄资料</p>
      </div>
      <div class="padding-left-20">
        <div class="list" v-if="haveIdPhoto">
          <div class="inner-list">
            <span>照片（App拍摄）</span>
            <span class="imp">*</span>
          </div>
        </div>
        <div
          v-for="material in activeIdentity.elec"
          class="list"
          :key="material.elec_id"
        >
          <div class="inner-list">
            <div class="material-name">
              <span v-text="material.elec_name"></span>
              <span v-if="material.type === 1" class="imp">*</span>
            </div>
            <div class="sample-example">
              <router-link
                class="template-btn"
                v-if="showSampleAndTemplate && material.template"
                :class="{ 'm-r-10': material.sample && material.sample.length }"
                :to="{
                  name: 'materialTemplate',
                  query: { url: material.template, name: material.elec_name },
                }"
                >模板</router-link
              >
              <router-link
                class="sample-btn"
                v-if="
                  showSampleAndTemplate &&
                  material.sample &&
                  material.sample.length
                "
                :to="{
                  name: 'materialTemplate',
                  query: { url: material.sample[0], name: material.elec_name },
                }"
                >样例</router-link
              >
            </div>
          </div>
          <ul class="disc">
            <template
              v-for="(attention, attentionIndex) in splitDescription(
                material.attention,
              )"
            >
              <li
                class="flex-center"
                :key="attentionIndex"
                v-text="attention"
                v-if="material.attention"
              ></li>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <!--邮寄资料-->
    <div class="app-data" v-if="activeIdentity.papery.length > 0">
      <div class="flexed-list-header">
        <span class="red-Popsicles"></span>
        <p>邮寄资料</p>
      </div>
      <div class="padding-left-20">
        <div
          v-for="material in activeIdentity.papery"
          class="list"
          :key="material.paper_id"
        >
          <div class="inner-list">
            <div class="material-name">
              <span v-text="material.paper_name"></span>
              <span v-if="material.type === 1" class="imp">*</span>
            </div>
            <div class="sample-example">
              <router-link
                class="template-btn"
                v-if="showSampleAndTemplate && material.template"
                :class="{ 'm-r-10': material.sample && material.sample.length }"
                :to="{
                  name: 'materialTemplate',
                  query: { url: material.template, name: material.paper_name },
                }"
                >模板</router-link
              >
              <router-link
                class="sample-btn"
                v-if="
                  showSampleAndTemplate &&
                  material.sample &&
                  material.sample.length
                "
                :to="{
                  name: 'materialTemplate',
                  query: { url: material.sample[0], name: material.paper_name },
                }"
                >样例</router-link
              >
            </div>
          </div>
          <ul class="disc">
            <template
              v-for="(attention, attentionIndex) in splitDescription(
                material.attention,
              )"
            >
              <li
                v-if="material.attention"
                class="flex-center"
                v-text="attention"
                :key="attentionIndex"
              ></li>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <!--面试携带资料-->
    <div class="app-data" v-if="activeIdentity.take.length > 0">
      <div class="flexed-list-header">
        <span class="red-Popsicles"></span>
        <p>面试携带资料</p>
      </div>
      <div class="padding-left-20">
        <div
          v-for="material in activeIdentity.take"
          class="list"
          :key="material.take_along_id"
        >
          <div class="inner-list">
            <div class="material-name">
              <span v-text="material.take_along_name"></span>
              <span v-if="material.type === 1" class="imp">*</span>
            </div>
            <div class="sample-example">
              <router-link
                class="template-btn"
                v-if="showSampleAndTemplate && material.template"
                :class="{ 'm-r-10': material.sample && material.sample.length }"
                :to="{
                  name: 'materialTemplate',
                  query: {
                    url: material.template,
                    name: material.take_along_name,
                  },
                }"
                >模板</router-link
              >
              <router-link
                class="sample-btn"
                v-if="
                  showSampleAndTemplate &&
                  material.sample &&
                  material.sample.length
                "
                :to="{
                  name: 'materialTemplate',
                  query: {
                    url: material.sample,
                    name: material.take_along_name,
                  },
                }"
                >样例</router-link
              >
            </div>
          </div>
          <ul class="disc">
            <template
              v-for="(attention, attentionIndex) in splitDescription(
                material.attention,
              )"
            >
              <li
                v-if="material.attention"
                class="flex-center"
                :key="attentionIndex"
                v-text="attention"
              ></li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'materialsOfIndentity',
  props: {
    activeIdentity: {
      type: Object,
      default() {
        return {};
      },
    },
    haveIdPhoto: {
      type: Number,
    },
    showSampleAndTemplate: {
      type: Boolean,
    },
  },
  methods: {
    splitDescription(description) {
      if (!description) return [];

      return description.split('\n');
    },
  },
};
</script>

<style scoped lang="less">
.app-data {
  &:first-of-type {
    margin-top: 0.2rem;
  }
}
.padding-left-20 {
  padding-left: 0.1rem;
}
.flexed-list-header {
  display: flex;
  margin-bottom: 0.17rem;
  font-size: 0.18rem;
  font-family: 'PingFangSC-Regular';
  font-weight: 500;
}
.red-Popsicles {
  display: inline-block;
  width: 0.03rem;
  height: 0.15rem;
  background-color: #ff5a60;
  margin-right: 0.1rem;
  margin-top: 0.01rem;
}
.list {
  padding: 0 0.03rem;
  color: #444;
  font-size: 0.14rem;
  margin-bottom: 0.17rem;
  padding-bottom: 0.17rem;
  border-bottom: 1px solid #f0f0f0;
}
.inner-list {
  margin-bottom: 0.05rem;
  display: flex;
  align-items: center;
  .material-name {
    flex: 1;
    font-size: 0.15rem;
  }
  .sample-example {
    display: flex;
    flex-wrap: no-wrap;
    width: 0.1.04rem;
    .m-r-10 {
      margin-right: 0.1rem;
    }
    a {
      width: 0.45rem;
      height: 0.24rem;
      border-radius: 0.03rem;
      font-size: 0.13rem;
      border-width: 1px;
      display: flex;
      text-align: center;
      border-style: solid;
      text-decoration: none;
      justify-content: center;
      align-items: center;
    }
    .template-btn {
      border-color: #ff5a60;
      color: #ff5a60;
    }
    .sample-btn {
      border-color: #aaa;
      color: #aaa;
    }
  }
}
span.imp {
  color: #ff5a60;
  margin: 0 0.02rem;
}
.materials-of-indentity li {
  line-height: 0.29rem;
}
.materials-of-indentity p {
  padding-bottom: 0.08rem;
  color: #6f6f6f;
  display: flex;
}
ul.disc {
  list-style-type: none;
  color: #444;
}
.disc .flex-center {
  align-items: center;
  color: #aaa;
  line-height: 0.25rem;
  font-size: 0.13rem;
}
</style>
